import {
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
  isRouteErrorResponse,
  useRouteError,
} from 'react-router';
import './styles/globals.css';

export function meta() {
  return [
    {
      name: 'description',
      content: 'Panel de gestión de creadores de contenido de la Red Educrea',
    },
    { title: 'Red de creadores de contenido Educrea' },
  ];
}

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <html lang="es-CL">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" type="image/svg+xml" href="/favicon.svg" />
        <Meta />
        <Links />
      </head>
      <body className="min-h-screen bg-background text-foreground antialiased">
        {children}
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
}

export default function App() {
  return <Outlet />;
}

export function ErrorBoundary() {
  const error = useRouteError();

  if (isRouteErrorResponse(error)) {
    return (
      <div className="flex min-h-screen items-center justify-center p-6">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-foreground">
            {error.status} {error.statusText}
          </h1>
          <p className="mt-2 text-muted-foreground">{error.data}</p>
        </div>
      </div>
    );
  }

  const message = error instanceof Error ? error.message : 'Error desconocido';
  return (
    <div className="flex min-h-screen items-center justify-center p-6">
      <div className="max-w-md text-center">
        <h1 className="text-2xl font-bold text-foreground">Algo salió mal</h1>
        <p className="mt-2 text-muted-foreground">{message}</p>
      </div>
    </div>
  );
}
